/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AutomaticValidationRequest,
  BronzeIdPreconfigRequest,
  BronzeIdStatusResponseDto,
  CommonRequestDto,
  InvestigationRequestDto,
  ManualValidationRejectionRequest,
  QuickInvestigationResultDto,
  ResponseDto,
} from '../models/index';
import {
    AutomaticValidationRequestFromJSON,
    AutomaticValidationRequestToJSON,
    BronzeIdPreconfigRequestFromJSON,
    BronzeIdPreconfigRequestToJSON,
    BronzeIdStatusResponseDtoFromJSON,
    BronzeIdStatusResponseDtoToJSON,
    CommonRequestDtoFromJSON,
    CommonRequestDtoToJSON,
    InvestigationRequestDtoFromJSON,
    InvestigationRequestDtoToJSON,
    ManualValidationRejectionRequestFromJSON,
    ManualValidationRejectionRequestToJSON,
    QuickInvestigationResultDtoFromJSON,
    QuickInvestigationResultDtoToJSON,
    ResponseDtoFromJSON,
    ResponseDtoToJSON,
} from '../models/index';

export interface InvestigationRequestRequest {
    investigationRequestDto: InvestigationRequestDto;
    mocked?: boolean;
    dnsCheckMocked?: boolean;
    captchaMocked?: boolean;
}

export interface ManualValidationRequest {
    encryptedParams: string;
}

export interface ManualValidationRejectionOperationRequest {
    manualValidationRejectionRequest: ManualValidationRejectionRequest;
}

export interface PreConfigRequest {
    bronzeIdPreconfigRequest: BronzeIdPreconfigRequest;
}

export interface RetryAutomaticValidationRequest {
    automaticValidationRequest: AutomaticValidationRequest;
}

export interface RetryIssuingRequest {
    commonRequestDto: CommonRequestDto;
}

export interface Status2Request {
    workflow?: string;
}

/**
 * 
 */
export class BronzeIdControllerApi extends runtime.BaseAPI {

    /**
     * Use cancellation instead
     * @deprecated
     */
    async cancelInstance2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/bronze-id/cancel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Use cancellation instead
     * @deprecated
     */
    async cancelInstance2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.cancelInstance2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Cancel Bronze id workflow instance, called by user
     */
    async cancellationInstance1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/bronze-id/cancellation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Cancel Bronze id workflow instance, called by user
     */
    async cancellationInstance1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.cancellationInstance1Raw(initOverrides);
        return await response.value();
    }

    /**
     * Also checks captcha
     * Create and start new Bronze id Credentials Workflow Instance
     */
    async investigationRequestRaw(requestParameters: InvestigationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuickInvestigationResultDto>> {
        if (requestParameters['investigationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'investigationRequestDto',
                'Required parameter "investigationRequestDto" was null or undefined when calling investigationRequest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mocked'] != null) {
            queryParameters['mocked'] = requestParameters['mocked'];
        }

        if (requestParameters['dnsCheckMocked'] != null) {
            queryParameters['dnsCheckMocked'] = requestParameters['dnsCheckMocked'];
        }

        if (requestParameters['captchaMocked'] != null) {
            queryParameters['captchaMocked'] = requestParameters['captchaMocked'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/bronze-id/investigation-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestigationRequestDtoToJSON(requestParameters['investigationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuickInvestigationResultDtoFromJSON(jsonValue));
    }

    /**
     * Also checks captcha
     * Create and start new Bronze id Credentials Workflow Instance
     */
    async investigationRequest(requestParameters: InvestigationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuickInvestigationResultDto> {
        const response = await this.investigationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Should be used without security, params are encrypted. Used in email link
     * Approve or disapprove the org investigation
     */
    async manualValidationRaw(requestParameters: ManualValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['encryptedParams'] == null) {
            throw new runtime.RequiredError(
                'encryptedParams',
                'Required parameter "encryptedParams" was null or undefined when calling manualValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/bronze-id/manual-validation/{encrypted-params}`.replace(`{${"encrypted-params"}}`, encodeURIComponent(String(requestParameters['encryptedParams']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Should be used without security, params are encrypted. Used in email link
     * Approve or disapprove the org investigation
     */
    async manualValidation(requestParameters: ManualValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.manualValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reject the org investigation
     */
    async manualValidationRejectionRaw(requestParameters: ManualValidationRejectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['manualValidationRejectionRequest'] == null) {
            throw new runtime.RequiredError(
                'manualValidationRejectionRequest',
                'Required parameter "manualValidationRejectionRequest" was null or undefined when calling manualValidationRejection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/bronze-id/manual-validation-rejection`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManualValidationRejectionRequestToJSON(requestParameters['manualValidationRejectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Reject the org investigation
     */
    async manualValidationRejection(requestParameters: ManualValidationRejectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.manualValidationRejectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Saves DNS text records, check mode and LEI to DB
     * Preconfiguration of Bronze id Credentials Workflow Instance
     */
    async preConfigRaw(requestParameters: PreConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['bronzeIdPreconfigRequest'] == null) {
            throw new runtime.RequiredError(
                'bronzeIdPreconfigRequest',
                'Required parameter "bronzeIdPreconfigRequest" was null or undefined when calling preConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/bronze-id/pre-config`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BronzeIdPreconfigRequestToJSON(requestParameters['bronzeIdPreconfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Saves DNS text records, check mode and LEI to DB
     * Preconfiguration of Bronze id Credentials Workflow Instance
     */
    async preConfig(requestParameters: PreConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.preConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Domain can be unacceptable for the first time or configuration may change, so automatic investigation can be retried
     * Retry automatic organization investigation
     */
    async retryAutomaticValidationRaw(requestParameters: RetryAutomaticValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['automaticValidationRequest'] == null) {
            throw new runtime.RequiredError(
                'automaticValidationRequest',
                'Required parameter "automaticValidationRequest" was null or undefined when calling retryAutomaticValidation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/bronze-id/retry-automatic-validation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutomaticValidationRequestToJSON(requestParameters['automaticValidationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Domain can be unacceptable for the first time or configuration may change, so automatic investigation can be retried
     * Retry automatic organization investigation
     */
    async retryAutomaticValidation(requestParameters: RetryAutomaticValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.retryAutomaticValidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Something bad can happen at first attempt of issuing. So we need to retry the attempt
     * Retry credential issuing
     */
    async retryIssuingRaw(requestParameters: RetryIssuingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['commonRequestDto'] == null) {
            throw new runtime.RequiredError(
                'commonRequestDto',
                'Required parameter "commonRequestDto" was null or undefined when calling retryIssuing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/bronze-id/retry-issuing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommonRequestDtoToJSON(requestParameters['commonRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Something bad can happen at first attempt of issuing. So we need to retry the attempt
     * Retry credential issuing
     */
    async retryIssuing(requestParameters: RetryIssuingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.retryIssuingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requests state machine and returns the status according to it. If workflow id is not set, finds one that was created by requester. If workflow is not found, returns 204
     * Return workflow status
     */
    async status2Raw(requestParameters: Status2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BronzeIdStatusResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/bronze-id/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BronzeIdStatusResponseDtoFromJSON(jsonValue));
    }

    /**
     * Requests state machine and returns the status according to it. If workflow id is not set, finds one that was created by requester. If workflow is not found, returns 204
     * Return workflow status
     */
    async status2(requestParameters: Status2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BronzeIdStatusResponseDto | null | undefined > {
        const response = await this.status2Raw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

}
